// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner-module__banner___2IM7n","icon":"Banner-module__icon___3p4pL"};